import script from "./ChangePsw.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePsw.vue?vue&type=script&setup=true&lang=js"

import "./ChangePsw.vue?vue&type=style&index=0&id=43c017ae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c017ae"]])

export default __exports__